"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.placeUserSchema = exports.placeUserInitialized = exports.placeUserFormInitialized = void 0;
const joi_1 = __importDefault(require("joi"));
const dataHelper_1 = require("../constants/dataHelper");
const data_1 = require("../constants/data");
const joiMessages_1 = require("../data/joiMessages");
const validations_1 = require("../data/validations");
exports.placeUserFormInitialized = {
    _id: '',
    email: '',
    role: '',
    subRole: '',
    countryPhoneCode: '',
    name: '',
    phone: '',
    emailInvitation: true,
    textType: '',
};
exports.placeUserInitialized = {
    ...exports.placeUserFormInitialized,
    // hasJoined: false,
    // inviteLink: '',
    // inviteLinkSent: false,
};
// VALIDATION SCHEMAS
let arr = (0, dataHelper_1.getAllObjectValuesArray)(data_1.PLACE_ROLES);
exports.placeUserSchema = joi_1.default.object({
    _id: joi_1.default.any().optional().allow(''),
    email: joi_1.default.string().optional().pattern(validations_1.emailRegex).messages({
        ...(0, joiMessages_1.joiStringMessage)({ name: 'Email', isRequired: true, patternText: 'has to be valid email' }),
    }),
    role: joi_1.default.string().allow(...arr).optional().messages({
        ...(0, joiMessages_1.joiStringMessage)({ name: 'Role', isRequired: true }),
    }),
    emailInvitation: joi_1.default.boolean().optional().allow(false),
    countryPhoneCode: joi_1.default.string().pattern(validations_1.countryCodeRegex).optional().allow('').max(4).messages({
        ...(0, joiMessages_1.joiStringMessage)({ name: 'Country code', patternText: 'has to be on the form "+123".' }),
    }),
    subRole: joi_1.default.string().optional().allow('').max(60).messages({
        ...(0, joiMessages_1.joiStringMessage)({ name: 'Sub role', patternText: 'has to be a string.' }),
    }),
    name: joi_1.default.string().optional().allow('').max(60).messages({
        ...(0, joiMessages_1.joiStringMessage)({ name: 'Name', patternText: 'has to be a string.' }),
    }),
    phone: joi_1.default.string().pattern(validations_1.numberRegex).optional().allow('').min(4).messages({
        ...(0, joiMessages_1.joiStringMessage)({ name: 'Phone', patternText: 'has to be a valid phone number.' }),
    }),
    textType: joi_1.default.string().optional().allow(''),
});
